import { render, staticRenderFns } from "./event-modal.vue?vue&type=template&id=5ffc690c&scoped=true"
import script from "./event-modal.vue?vue&type=script&lang=js"
export * from "./event-modal.vue?vue&type=script&lang=js"
import style0 from "./event-modal.vue?vue&type=style&index=0&id=5ffc690c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffc690c",
  null
  
)

export default component.exports